// src/services/identity/townlitVerificationApi.ts

import baseApi from "../../lib/baseApi";
import type {
  TownlitVerificationEligibilityDTO,
  TownlitVerificationStatusDTO,
} from "../../types/identity/townlitVerificationTypes";

const townlitVerificationApi = {
  async fetchEligibility(): Promise<TownlitVerificationEligibilityDTO> {
    const response = await baseApi.get("/accounts/townlit-verification/eligibility/");
    return response.data;
  },

  async fetchStatus(): Promise<TownlitVerificationStatusDTO> {
    const response = await baseApi.get("/accounts/townlit-verification/status/");
    return response.data;
  },
};

export default townlitVerificationApi;